import 'intl-tel-input/styles'

import { cva, cx } from '@zenchef/styled-system/css'
import IntlTelInput, { IntlTelInputRef } from 'intl-tel-input/react'
import React, { useCallback, useEffect, useRef, useState } from 'react'

import { telInputRecipe } from '@/components/ui/CustomTelInput/CustomTelInputRecipes'

type CustomTelInputProps = {
  onPhoneNumberChange: (isValid: boolean, value: string, countryIso: string, valueFormatted: string) => void
  error: boolean
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void
  name?: string
  value?: string
  mini?: boolean
  autoFocus?: boolean
  required?: boolean
  className?: string
  defaultCountry?: string
}

const CustomTelInput = (props: CustomTelInputProps) => {
  const {
    onPhoneNumberChange,
    onBlur,
    name = 'phone',
    value,
    mini,
    error,
    autoFocus,
    required,
    className,
    defaultCountry = 'fr'
  } = props

  const [isInternalStateValid, setIsInternalStateValid] = useState<boolean>(false)
  const [countryCode, setCountryCode] = React.useState<string>('')

  const inputRef = useRef<IntlTelInputRef>(null)

  const classes = telInputRecipe({ error, mini })

  const onChangeCountry = useCallback((country: string) => {
    setCountryCode(country)
  }, [])
  const onChangeValidity = useCallback((valid: boolean) => {
    setIsInternalStateValid(valid)
  }, [])
  const onChangeNumber = useCallback(
    (phoneNum: string) => {
      onPhoneNumberChange(isInternalStateValid, phoneNum, countryCode === 'gb' ? 'uk' : countryCode, phoneNum)
    },
    [countryCode, isInternalStateValid]
  )
  const onChangeErrorCode = useCallback(() => {}, [])

  useEffect(() => {
    if (value && value !== inputRef.current?.getInput()?.value) {
      inputRef.current?.getInstance()?.setNumber(value)
    }
  }, [value])

  return (
    <div className={cx(className, classes)}>
      <IntlTelInput
        ref={inputRef}
        initialValue={value}
        onChangeNumber={onChangeNumber}
        onChangeErrorCode={onChangeErrorCode}
        onChangeCountry={onChangeCountry}
        onChangeValidity={onChangeValidity}
        initOptions={{
          strictMode: true,
          nationalMode: false,
          loadUtils: () => import('intl-tel-input/build/js/utils'),
          initialCountry: defaultCountry,
          formatOnDisplay: true
        }}
        inputProps={{
          id: name,
          name,
          required,
          onBlur,
          ...(autoFocus ? { autoFocus } : {}),
          'data-testid': 'phone-input'
        }}
      />
    </div>
  )
}

export default CustomTelInput
